import isMobile from '../services/mobile';
import { mobileAction } from '../providers/redux/mobile';

export default store => window
  .addEventListener('resize', () => store.dispatch(mobileAction(isMobile())));
